<template>
    <div v-if="route">
        <el-button
            class="go-to-button"
            size='small'
            @click='goTo(route)'
        >
            <span class="go-to-button__content">
                {{ text }}
                <i :class="icon"></i>
            </span>
        </el-button>
    </div>
</template>

<script>
export default {
    name: 'GoToButton',
    props: {
        text: {
            type: String,
            required: false,
            default: () => ''
        },
        icon: {
            type: String,
            required: false,
            default: () => ''
        },
        route: {
            type: String,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {
        goTo(route) {
            this.$router.push({
                name: route
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.go-to-button {
    width: 100%;
    background-color: #FBFBFB;
    border: none;
    .go-to-button__content {
        color: var(--primary);
    }
}
@media only screen and (max-width: 1334px) {
}
</style>
